import { Component } from '@angular/core';

@Component({
  selector: 'app-area-chart',
  template: '<app-chart-output></app-chart-output>'
})
export class AreaChartComponent {

}
